import Dashboards from './dashboards';

export default Dashboards;
